{
  "common": {
    "dateTbc": "Dată nestabilită",
    "cancelled": "anulată"
  },
  "dashboard": {
    "eventConfirmed": "confirmat",
    "eventPending": "în așteptare",
    "eventNotApproved": "neaprobat",
    "eventOpen": "deschis"
  },
  "payments": {
    "outstanding": "De plată",
    "itemsDue": "Plăți scadente",
    "creditBalance": "Sold credit",
    "creditNote": "Creditul tău se aplică automat plăților viitoare.",
    "dueLabel": "Scadent la {date}",
    "overdue": "întârziat",
    "pay": "Plătește",
    "payNoteOnline": "Plătește în siguranță cu cardul sau personal / prin transfer bancar (școala le va marca drept plătite).",
    "payNoteOffline": "Plătește personal sau prin transfer bancar — școala le va marca drept plătite.",
    "allPaidUp": "Ești la zi cu plățile",
    "noOutstanding": "Nu ai plăți restante.",
    "history": "Istoric",
    "paidOn": "Plătit la {date}",
    "cancelledStatus": "Anulat",
    "noHistory": "Încă nu există istoric de plăți.",
    "paymentLabel": "Plată"
  },
  "events": {
    "eventFallback": "Eveniment",
    "notRegistered": "Neînscris",
    "pendingApproval": "În așteptarea aprobării",
    "confirmed": "Confirmat",
    "notApproved": "Neaprobat",
    "paid": "Plătit",
    "paymentDue": "Plată scadentă",
    "noEvents": "Niciun eveniment",
    "noEventsMessage": "Momentan nu există evenimente disponibile pentru tine."
  },
  "eventDetail": {
    "allEvents": "Toate evenimentele",
    "dateTbc": "Dată de confirmat",
    "eventDetails": "Detalii eveniment",
    "photosVideos": "Fotografii și videoclipuri",
    "confirmedHeading": "Ești confirmat",
    "feeAdded": "Taxa pentru eveniment a fost adăugată în contul tău.",
    "goToPayments": "Mergi la Plăți",
    "feeTbd": "Școala te va anunța dacă există o taxă de plătit.",
    "deniedNote": "Cererea ta de participare nu a fost aprobată. Te rugăm să contactezi școala dacă ai întrebări.",
    "interestedNote": "Ți-ai exprimat interesul{fee}. Școala îți va confirma locul.",
    "withdrawInterest": "Retrage interesul",
    "withdrawConfirm": "Retragi interesul pentru acest eveniment?",
    "registrationClosed": "Înscrierile pentru acest eveniment sunt închise.",
    "registerHeading": "Exprimă-ți interesul",
    "chooseOption": "Alege opțiunea care te interesează:",
    "agreeWithDetails": "Am citit detaliile evenimentului și sunt de acord cu condițiile",
    "agreeNoDetails": "Sunt de acord cu condițiile evenimentului",
    "registerInterest": "Exprimă interesul",
    "selectOption": "Selectează o opțiune de mai sus."
  },
  "gallery": {
    "submitNote": "Adaugă propriile fotografii sau videoclipuri — vor fi verificate de școală înainte de a apărea în galerie.",
    "dropLabel": "Trage fotografii sau videoclipuri aici sau dă clic pentru a le trimite",
    "noMedia": "Încă nu există media",
    "noMediaMessage": "Fotografiile și videoclipurile aprobate vor apărea aici.",
    "noPhotos": "Încă nu există fotografii",
    "noPhotosEvent": "Încă nu există albume foto pentru acest eveniment.",
    "all": "Toate",
    "unfiled": "Neclasificate",
    "filterBy": "Filtrează după",
    "lastUpdated": "Ultima actualizare",
    "dateTaken": "Data realizării",
    "to": "până la",
    "fromDate": "De la data",
    "toDate": "Până la data",
    "clear": "Șterge",
    "noAlbumsMatch": "Niciun album găsit",
    "noAlbumsMatchMessage": "Încearcă alt interval de date sau șterge filtrul.",
    "allAlbums": "Toate albumele",
    "clearSelection": "Anulează selecția",
    "selectedCount": "{count} selectate",
    "selectAll": "Selectează tot ({count})",
    "download": "Descarcă",
    "preparingZip": "Se pregătește ZIP-ul",
    "emptyAlbum": "Album gol",
    "emptyAlbumMessage": "Încă nu există media aprobată aici.",
    "select": "Selectează",
    "openFull": "Deschide complet",
    "close": "Închide",
    "itemOne": "{count} element",
    "itemOther": "{count} elemente"
  },
  "profile": {
    "name": "Nume",
    "email": "E-mail",
    "dateOfBirth": "Data nașterii",
    "phone": "Telefon",
    "emergencyContact": "Contact de urgență",
    "emergencyPhone": "Telefon de urgență",
    "medicalNotes": "Note medicale"
  },
  "toast": {
    "paymentReceived": "Plată primită — mulțumim!",
    "paymentCanceled": "Plată anulată",
    "interestRegistered": "Interes înregistrat — școala îți va analiza cererea.",
    "interestWithdrawn": "Interes retras",
    "saved": "Salvat",
    "photoUpdated": "Fotografie actualizată",
    "fetchFailed": "Nu s-a putut descărca {name}",
    "downloadedOne": "S-a descărcat {count} element ca {name}",
    "downloadedOther": "S-au descărcat {count} elemente ca {name}",
    "downloadFailed": "Descărcare eșuată: {message}",
    "submittedOne": "{count} element trimis spre aprobare",
    "submittedOther": "{count} elemente trimise spre aprobare",
    "failedSuffix": ", {count} eșuate",
    "skippedUnsupported": "S-a omis „{name}” — tip neacceptat"
  }
}
